<form [formGroup]="menuService?.form" (ngSubmit)="saveAndContinue()" class="px-0 px-sm-3"
    [ngClass]="{ 'py-5 position-relative': isDialog }">
    <i matTooltip="Cerrar" class="fas fa-times fa-2xl close-icon-actions" *ngIf="isDialog"
        (click)="dialogRef.close()"></i>
    <div class="container-fluid">
        <h4 *ngIf="isDialog" class="text-bold text-center px-3">
            Observaciones
        </h4>

        <div class="row">
            <p class="col-md-12 text-bold">Observaciones Internas</p>
            <div class="col-md-12">
                <mat-form-field appearance="outline">
                    <mat-label>Notas Adicionales <span class="optional">(opcional)</span></mat-label>
                    <input matInput type="text" [formControl]="observations" placeholder="Observaciones">
                </mat-form-field>
            </div>

            <p class="col-md-12 text-bold" *ngIf="!menuService?.isSatelliteLockService()">
                Requisitos para el {{menuService?.isEscortedService() ? 'escolta' : 'conductor'}}
            </p>
            <div class="col-md-12" *ngIf="!menuService?.isSatelliteLockService()">
                <mat-form-field appearance="outline">
                    <mat-label>Notas adicionales <span class="optional">(opcional)</span></mat-label>
                    <input matInput type="text" [formControl]="observationsToDriver"
                        [placeholder]="'Observaciones para el' + (menuService?.isEscortedService() ? 'escolta' : 'conductor')">
                </mat-form-field>
            </div>
        </div>

        <!-- Action buttons -->
        <div *ngIf="!isDialog; else dialogButtons" class="button-container mt-4">
            <button mat-raised-button color="primary" class="button-width-auto primary-secondary button-small"
                [ngClass]="{'warn': true}" type="button" (click)="backToPreviousStep()">
                <span class="mat-button-wrapper">Atras</span>
            </button>
            <button class="mx-2" type="submit" mat-raised-button color="accent" *ngIf="canEditObservations">
                Guardar y Continuar
            </button>
            <button class="mx-2" type="button" mat-raised-button color="accent" (click)="continueToNextStep()"
                *ngIf="!canEditObservations">
                Continuar
            </button>
        </div>
        <ng-template #dialogButtons>
            <div class="button-container mt-4">
                <button class="mx-2" type="submit" mat-raised-button color="accent">
                    Guardar
                </button>
            </div>
        </ng-template>
    </div>
</form>